import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Divider,
  Chip,
} from '@mui/material';
import {
  Logout as LogoutIcon,
  Help as HelpIcon,
  VerifiedUser as CertificateIcon,
  Download as DownloadIcon,
  Checklist as ChecklistIcon,
  Group as GroupIcon,
  ExpandMore as ExpandMoreIcon,
  Tune as TuneIcon,
  Science as ScienceIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

const DoHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [helpMenuAnchor, setHelpMenuAnchor] = useState(null);

  useEffect(() => {
    // Get username from localStorage
    const storedUsername = localStorage.getItem('username') || sessionStorage.getItem('username');
    
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, [location]);

     const handleLogout = () => {
  localStorage.clear();

  // Trigger logout event for other tabs
  localStorage.setItem("logout", Date.now());

  // Redirect current tab
  navigate('/main/login')
};

  const handleHelp = () => {
    // Open medical specific help manual
    window.open('/main/help/medical-laboratory', '_blank');
  };

  const handleHelpMenuOpen = (event) => {
    setHelpMenuAnchor(event.currentTarget);
  };

  const handleHelpMenuClose = () => {
    setHelpMenuAnchor(null);
  };

  const handleCreateSubUser = () => {
    handleHelpMenuClose();
    navigate('/main/medical/sub-user');
  };

  const handleHelpManual = () => {
    handleHelpMenuClose();
    // Download medical specific help manual
    const link = document.createElement('a');
    link.href = '/main/assets/medical_Laboratory_Guide.pdf';
    link.download = 'medical_Laboratory_Guide.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleChecklist = () => {
    handleHelpMenuClose();
    // Open medical specific checklist
    window.open('/main/medical-checklist.html', '_blank');
  };

  const handleScopeDocuments = () => {
    handleHelpMenuClose();
    // Open scope documents
    window.open('/main/medical-scope-documents', '_blank');
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #3b82f6 100%)',
        color: 'white',
        boxShadow: '0 4px 20px rgba(30, 60, 114, 0.3)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar sx={{ minHeight: 64, px: 0 }}>
          {/* Brand/Logo Section */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box 
                       sx={{ 
                         display: 'flex', 
                         alignItems: 'center', 
                         cursor: 'pointer',
                         paddingY:1,
                         '&:hover': {
                           opacity: 0.9,
                         },
                         transition: 'opacity 0.3s ease',
                       }}
                       
                     >
                         <img src='/main/images/v1_9old.png' style={{width:'60px'}} alt="Logo" />
                     </Box>
            <Typography
              variant="h6"
              component="div"
              sx={{
                fontWeight: 700,
                color: 'white',
                letterSpacing: '1px',
                textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              }}
            >
              NABL
            </Typography>
          </Box>

          {/* Application Type Indicator */}
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              {username && (
                <Box
                  sx={{
                    background: 'rgba(255, 255, 255, 0.15)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: '20px',
                    px: 3,
                    py: 1,
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      color: 'white',
                      textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
                    }}
                  >
                    Welcome, {username}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* medical Specific Help Menu */}
            {/* <Button
              variant="outlined"
              endIcon={<ExpandMoreIcon />}
              onClick={handleHelpMenuOpen}
              sx={{
                borderColor: 'rgba(255, 255, 255, 0.5)',
                color: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                },
                transition: 'all 0.3s ease',
                fontWeight: 600,
              }}
            >
              Medical Tools
            </Button> */}

            <Menu
              anchorEl={helpMenuAnchor}
              open={Boolean(helpMenuAnchor)}
              onClose={handleHelpMenuClose}
              PaperProps={{
                sx: {
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: 2,
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                  mt: 1,
                },
              }}
            >
              <MenuItem 
                onClick={handleCreateSubUser}
                sx={{
                  py: 1.5,
                  px: 3,
                  '&:hover': {
                    backgroundColor: 'rgba(30, 60, 114, 0.1)',
                  },
                }}
              >
                <GroupIcon sx={{ mr: 2, color: '#1e3c72' }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Create Sub User
                </Typography>
              </MenuItem>
              
              <Divider />
              
              <MenuItem 
                onClick={handleScopeDocuments}
                sx={{
                  py: 1.5,
                  px: 3,
                  '&:hover': {
                    backgroundColor: 'rgba(30, 60, 114, 0.1)',
                  },
                }}
              >
                <TuneIcon sx={{ mr: 2, color: '#1e3c72' }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Scope Documents
                </Typography>
              </MenuItem>
              
              <MenuItem 
                onClick={handleHelpManual}
                sx={{
                  py: 1.5,
                  px: 3,
                  '&:hover': {
                    backgroundColor: 'rgba(30, 60, 114, 0.1)',
                  },
                }}
              >
                <DownloadIcon sx={{ mr: 2, color: '#1e3c72' }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Medical Guide
                </Typography>
              </MenuItem>
              
              <MenuItem 
                onClick={handleChecklist}
                sx={{
                  py: 1.5,
                  px: 3,
                  '&:hover': {
                    backgroundColor: 'rgba(30, 60, 114, 0.1)',
                  },
                }}
              >
                <ChecklistIcon sx={{ mr: 2, color: '#1e3c72' }} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Medical Checklist
                </Typography>
              </MenuItem>
            </Menu>
            
            <Button
              variant="outlined"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              sx={{
                borderColor: 'rgba(255, 255, 255, 0.5)',
                color: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(10px)',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  transform: 'translateY(-1px)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                },
                transition: 'all 0.3s ease',
                fontWeight: 600,
              }}
            >
              Logout
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default DoHeader;
